module.exports = __webpack_public_path__ + "65ecff5976e704f9185d8d3498af1f00.svg";